"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@coreui/react");
const lodash_1 = require("lodash");
const react_2 = require("react");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const config_1 = require("config");
const merchant_management_v1_api_1 = require("merchant-management-v1-api");
const merchant_portal_components_1 = require("merchant-portal-components");
const utils_1 = require("utils");
const ProgramManagementConfirmModal_1 = __importDefault(require("../../../../components/ProgramManagementConfirmModal"));
const enabledLocationKeys = [
    'payMyProviderEnabled',
    'dashboardEnabled',
    'minPurchaseAmount',
];
function ACCard({ currentLocation, }) {
    const [skipPricingTiers, setSkipPricingTiers] = (0, react_2.useState)(true);
    // Query - Get/Skip
    const { data: dataPricingTiers, isFetching: isLoadingPricingTiers, refetch: refetchPricingTiers, } = (0, merchant_management_v1_api_1.useGetMerchantManagementV1LocationsIdPricingTiersQuery)({
        id: Number(currentLocation.locationId),
    }, {
        skip: skipPricingTiers,
    });
    // Query - Patch
    const [updateLocationPlans] = (0, merchant_management_v1_api_1.usePatchMerchantManagementV1LocationsIdPlansMutation)();
    const pricingTiers = (0, react_2.useMemo)(() => {
        if (!dataPricingTiers)
            return undefined;
        const tmpPricingTiers = dataPricingTiers;
        return tmpPricingTiers.pricingTiers;
    }, [dataPricingTiers]);
    // State
    const [cancelTrigger, setCancelTrigger] = (0, react_2.useState)(0);
    const [initialAccessLoanPlanSettings, setInitialAccessLoanPlanSettings] = (0, react_2.useState)([]);
    const [initialLocPlanSettings, setInitialLocPlanSettings] = (0, react_2.useState)([]);
    const [accessLoanPlanSettings, setAccessLoanPlanSettings] = (0, react_2.useState)([]);
    const [locPlanSettings, setLocPlanSettings] = (0, react_2.useState)([]);
    const [locPlanSettingsChanges, setLocPlanSettingsChanges] = (0, react_2.useState)(new Map());
    const [accessLoanPlanChanges, setAccessLoanPlanChanges] = (0, react_2.useState)(new Map());
    const [accessLoanPlanBeforeAndAfterArray, setAccessLoanPlanBeforeAndAfterArray,] = (0, react_2.useState)([]);
    const [locPlanBeforeAndAfterArray, setLocPlanBeforeAndAfterArray] = (0, react_2.useState)([]);
    const [showConfirmationModal, setShowConfirmationModal] = (0, react_2.useState)(false);
    const [updatingLocationPlans, setUpdatingLocationPlans] = (0, react_2.useState)(false);
    // Memos
    const adsPricingTier = (0, react_2.useMemo)(() => {
        if (!pricingTiers)
            return undefined;
        return pricingTiers.find((pricingTier) => pricingTier.serviceProviderName == 'ADS');
    }, [pricingTiers]);
    const coveredCarePricingTier = (0, react_2.useMemo)(() => {
        if (!pricingTiers)
            return undefined;
        return pricingTiers.find((pricingTier) => pricingTier.serviceProviderName == 'Covered Care');
    }, [pricingTiers]);
    const adsPlans = (0, react_2.useMemo)(() => {
        if (!adsPricingTier)
            return undefined;
        let plans = [];
        adsPricingTier.planGroups.forEach((planGroup) => (plans = plans.concat(planGroup.plans)));
        return plans;
    }, [adsPricingTier]);
    const coveredCarePlans = (0, react_2.useMemo)(() => {
        if (!coveredCarePricingTier)
            return [];
        let plans = [];
        coveredCarePricingTier.planGroups.forEach((planGroup) => (plans = plans.concat(planGroup.plans)));
        return plans;
    }, [coveredCarePricingTier]);
    const showPartnerMessage = (0, react_2.useMemo)(() => {
        const tmpPricingTiers = dataPricingTiers;
        if (tmpPricingTiers && tmpPricingTiers.pricingTiers) {
            const hasActive = tmpPricingTiers.pricingTiers.filter((itm) => {
                return (itm.priorityIsActive === false &&
                    itm.serviceProviderName === 'Covered Care');
            });
            return !!hasActive.length;
        }
        else {
            return false;
        }
    }, [dataPricingTiers]);
    // Effects
    (0, react_2.useEffect)(() => {
        setSkipPricingTiers(false);
    }, [currentLocation]);
    (0, react_2.useEffect)(() => {
        if (coveredCarePlans == undefined)
            return;
        setInitialAccessLoanPlanSettings((0, lodash_1.cloneDeep)(coveredCarePlans));
        setAccessLoanPlanSettings((0, lodash_1.cloneDeep)(coveredCarePlans));
    }, [coveredCarePlans]);
    (0, react_2.useEffect)(() => {
        if (adsPlans == undefined)
            return;
        setInitialLocPlanSettings((0, lodash_1.cloneDeep)(adsPlans));
        setLocPlanSettings((0, lodash_1.cloneDeep)(adsPlans));
    }, [adsPlans]);
    const changesMadeForLoc = () => {
        return locPlanSettingsChanges.size > 0;
    };
    const changesMadeForAccessLoans = () => {
        return accessLoanPlanChanges.size > 0;
    };
    const handleAccessLoanPlanChange = (plan) => {
        const newAccessLoanPlanChanges = new Map();
        if (plan != undefined) {
            newAccessLoanPlanChanges.set(plan.id, plan);
        }
        setAccessLoanPlanChanges(newAccessLoanPlanChanges);
    };
    const handleLocPlanCancel = () => {
        setCancelTrigger(Date.now());
        resetData();
    };
    const handleLocPlanChange = (plan) => {
        const newLocPlanChanges = new Map(locPlanSettingsChanges);
        newLocPlanChanges.set(plan.id, plan);
        setLocPlanSettingsChanges(newLocPlanChanges);
    };
    const putTogetherPlanUpdate = (plan, changeLog) => {
        const planUpdate = { plan_id: plan.id };
        enabledLocationKeys.forEach((key) => {
            const initialValue = plan[key];
            const newValue = changeLog[key];
            if (initialValue != newValue) {
                planUpdate[key] = changeLog[key];
            }
        });
        return planUpdate;
    };
    const determinePlanDiffForUpdate = () => {
        const planUpdateBody = [];
        const appendToUpdateBody = (plan, changeMap) => {
            const changeLog = changeMap.get(plan.id);
            if (changeLog != undefined && !(0, lodash_1.isEqual)(changeLog, plan)) {
                const planUpdate = putTogetherPlanUpdate(plan, changeLog);
                planUpdateBody.push(planUpdate);
            }
        };
        const appendToUpdateBodyAccess = (plan, changeMap) => {
            const changeLog = changeMap.get(plan.id);
            if (changeMap.size > 0 && changeLog == undefined) {
                const planUpdate = { plan_id: plan.id, dashboardEnabled: false };
                planUpdateBody.push(planUpdate);
            }
            if (changeLog != undefined && !(0, lodash_1.isEqual)(changeLog, plan)) {
                const planUpdate = putTogetherPlanUpdate(plan, changeLog);
                planUpdateBody.push(planUpdate);
            }
        };
        initialLocPlanSettings &&
            initialLocPlanSettings.forEach((plan) => {
                appendToUpdateBody(plan, locPlanSettingsChanges);
            });
        initialAccessLoanPlanSettings &&
            accessLoanPlanChanges.size > 0 &&
            initialAccessLoanPlanSettings.forEach((plan) => {
                appendToUpdateBodyAccess(plan, accessLoanPlanChanges);
            });
        return planUpdateBody;
    };
    const submitChanges = () => {
        setUpdatingLocationPlans(true);
        const locationPlanUpdates = determinePlanDiffForUpdate();
        const updateBody = { plans: locationPlanUpdates };
        updateLocationPlans({
            id: currentLocation.locationId,
            patchMerchantManagementV1LocationsIdPlans: updateBody,
        })
            .then(() => {
            setShowConfirmationModal(false);
            refetchPricingTiers();
            setUpdatingLocationPlans(false);
            (0, utils_1.toastSuccess)('Program Settings Updated Successfully');
            resetData();
        })
            .catch((error) => {
            (0, utils_1.reportError)('flashError', {
                componentName: 'ProgramManagement',
                funcName: 'updateLocationPlans',
                errType: 'db',
                errCode: error?.response?.errorCode,
                errURL: window.location.pathname,
                errMsg: error?.response?.message,
                errLocation: currentLocation.locationId,
            }, error);
            (0, utils_1.toastError)((0, utils_1.apiErrorToErrorMessage)(error?.response?.errorCode, error?.response?.message));
        });
    };
    const determinePlanDiffForModal = () => {
        const putTogetherModalPlanChanges = (plan, changeLog, planChangeArray) => {
            if (changeLog != undefined && !(0, lodash_1.isEqual)(changeLog, plan)) {
                enabledLocationKeys.forEach((key) => {
                    const initialValue = plan[key];
                    const newValue = changeLog[key];
                    if (initialValue != newValue) {
                        planChangeArray.push({
                            name: plan.name,
                            id: plan.id,
                            field: key,
                            from: initialValue,
                            to: changeLog[key],
                            plan: plan,
                        });
                    }
                });
            }
        };
        initialAccessLoanPlanSettings != undefined &&
            initialAccessLoanPlanSettings.forEach((plan) => {
                const changeLog = accessLoanPlanChanges.get(plan.id);
                putTogetherModalPlanChanges(plan, changeLog, accessLoanPlanBeforeAndAfterArray);
            });
        initialLocPlanSettings != undefined &&
            initialLocPlanSettings.forEach((plan) => {
                const changeLog = locPlanSettingsChanges.get(plan.id);
                putTogetherModalPlanChanges(plan, changeLog, locPlanBeforeAndAfterArray);
            });
        setLocPlanBeforeAndAfterArray(locPlanBeforeAndAfterArray);
        setAccessLoanPlanBeforeAndAfterArray(accessLoanPlanBeforeAndAfterArray);
        if (locPlanBeforeAndAfterArray.length > 0 ||
            accessLoanPlanBeforeAndAfterArray.length > 0) {
            setShowConfirmationModal(true);
        }
        else {
            //do something to prompt the user for changes
        }
    };
    const closeModal = () => {
        setShowConfirmationModal(false);
        resetBeforeAndAfterArray();
    };
    const resetBeforeAndAfterArray = () => {
        setAccessLoanPlanBeforeAndAfterArray([]);
        setLocPlanBeforeAndAfterArray([]);
    };
    const resetPlanChanges = () => {
        setLocPlanSettingsChanges(new Map());
        setAccessLoanPlanChanges(new Map());
    };
    const resetData = () => {
        resetBeforeAndAfterArray();
        resetPlanChanges();
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isLoadingPricingTiers && (0, jsx_runtime_1.jsx)(components_1.Spinner, {}), (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "w100", children: (0, jsx_runtime_1.jsx)(merchant_portal_components_1.PricingTierCard, { pricingTier: adsPricingTier }) }), (0, jsx_runtime_1.jsx)("div", { className: "dashboard dashboard--header", children: "Promotional Plans" }), (0, jsx_runtime_1.jsx)("div", { className: "program-management__settings--table m-t-50", children: (0, jsx_runtime_1.jsx)(merchant_portal_components_1.PlanSettingsTable, { plans: locPlanSettings, onChange: handleLocPlanChange, onCancel: cancelTrigger }) }), (coveredCarePricingTier || showPartnerMessage) && ((0, jsx_runtime_1.jsx)("div", { className: "dashboard dashboard--header", children: "Alphaeon Access Loan" })), showPartnerMessage ? ((0, jsx_runtime_1.jsx)("div", { className: "partner-notice", children: (0, jsx_runtime_1.jsx)("p", { children: "The partner that originates Alphaeon Access Loans is currently performing platform upgrades and you might experience delays or other issues with providing this option to your patients. Please be assured that we are working closely with this partner to bring functionality back to optimal performance and expect to have the issues completely resolved early in 2024. If you need assistance during this time, please contact your Business Development Manager or Practice Support 1-920-306-1794." }) })) : null, (0, jsx_runtime_1.jsx)("div", { children: !showPartnerMessage && coveredCarePricingTier && ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.PlanOptionsSelection, { plans: accessLoanPlanSettings, onChange: handleAccessLoanPlanChange })) }), (0, jsx_runtime_1.jsxs)("div", { className: `button-block ${!changesMadeForLoc() && !changesMadeForAccessLoans()
                            ? 'display-none'
                            : 'display-initial'}`, children: [(0, jsx_runtime_1.jsx)(react_1.CButton, { size: 'lg', color: "primary", shape: "rounded-pill", onClick: () => determinePlanDiffForModal(), className: `button-warn-outline ${!changesMadeForLoc() && !changesMadeForAccessLoans()
                                    ? `warn-disabled`
                                    : ``}`, disabled: !changesMadeForLoc() && !changesMadeForAccessLoans(), children: "SAVE" }), (0, jsx_runtime_1.jsx)(react_1.CButton, { as: react_router_dom_1.Link, size: "lg", variant: "outline", shape: "rounded-pill", color: "link", to: config_1.PROGRAM_MANAGEMENT_URL, onClick: (e) => {
                                    e.preventDefault();
                                    handleLocPlanCancel();
                                }, children: "CANCEL" })] }), showConfirmationModal && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(ProgramManagementConfirmModal_1.default, { locPlanDiff: locPlanBeforeAndAfterArray, accessLoanPlanDiff: accessLoanPlanBeforeAndAfterArray, onClose: closeModal, updatingLocationPlans: updatingLocationPlans, onSubmitChanges: submitChanges }) }))] })] }));
}
exports.default = ACCard;
